import { render, staticRenderFns } from "./BaseValidationMark.vue?vue&type=template&id=12aa805e&"
import script from "./BaseValidationMark.vue?vue&type=script&lang=js&"
export * from "./BaseValidationMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports